import styled from 'styled-components'

export const Button = styled('button')`
  padding: 0px;
  margin: 0px;
  border: 0px;
  background: none;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`